/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const PhoneSquareIconConfig = {
  name: 'PhoneSquareIcon',
  height: 512,
  width: 448,
  svgPath: 'M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(PhoneSquareIconConfig);
//# sourceMappingURL=phone-square-icon.js.map